import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CONSENT_KEY } from "@/components/CookieConsent";

const hasConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY) === "accepted";
  } catch {
    return false;
  }
};

export default function GATracker() {
  const id = process.env.REACT_APP_GA_ID;
  const location = useLocation();
  const [allowed, setAllowed] = useState(hasConsent);

  useEffect(() => {
    const onChange = () => setAllowed(hasConsent());
    window.addEventListener("eid-consent-changed", onChange);
    return () => window.removeEventListener("eid-consent-changed", onChange);
  }, []);

  useEffect(() => {
    if (!id || !allowed || window.gtag) return;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", id, { send_page_view: false });
  }, [id, allowed]);

  useEffect(() => {
    if (id && allowed && window.gtag) {
      window.gtag("event", "page_view", { page_path: location.pathname + location.search });
    }
  }, [id, allowed, location]);

  return null;
}
